interface ServerErrorField {
  property: string;
  message: string;
}

export interface ServerErrorFields {
  errors: ServerErrorField[];
}

export type ServerError = string | ServerErrorFields | Error | null;
export interface ServerErrorByProp {
  common?: string;
  [key: string]: string | undefined;
}

function isLoginServerErrorField(error: ServerError): error is ServerErrorFields {
  return !!error && typeof error === 'object' && !!(error as ServerErrorFields).errors;
}

function isError(error: ServerError): error is Error {
  return !!error && typeof error === 'object' && !!(error as Error).message;
}

export function getServerErrorByProp<T extends ServerErrorByProp>(serverError: ServerError): T {
  const output = {} as any;

  if (!serverError) {
    return output;
  }

  if (typeof serverError === 'string') {
    output.common = serverError;
    return output;
  }

  if (isLoginServerErrorField(serverError) && serverError.errors.length) {
    serverError.errors.forEach(err => {
      output[err.property] = err.message;
    });
    return output;
  }

  if (isError(serverError)) {
    output.common = serverError.message;
  }

  return output;
}
